import * as  Card from '@/components/ui/card'
import SimpleRichText from "@components/SimpleRichText"
import { onMount } from "solid-js"
import { useService } from "solid-services"
import { Container } from "styled-system/jsx"
import { useLessonState } from "./state"

export default function () {
  const { lessonQuery, setRequirementsMet } = useService(useLessonState)()

  onMount(() => {
    setRequirementsMet(true)
  })

  return (
    <Container>
      <Card.Root p={6}>
        <SimpleRichText content={lessonQuery.data?.content || ''} />
      </Card.Root>
    </Container>
  )
}
